const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.072,
  y1: 0.488,
  x2: 0.916,
  y2: 0.488,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#63d1a2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63c3d1"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(143.105) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M279.051,1261.287l35.811-21.829,1.4,2.251a50.924,50.924,0,0,0,86.963-53.01l-1.362-2.272,35.811-21.83,1.386,2.3a92.872,92.872,0,0,1-158.6,96.677Zm34.119-14.547-26.729,16.293a87.535,87.535,0,0,0,149.4-91.066l-26.729,16.293a56.262,56.262,0,0,1-95.937,58.48Z",
  transform: "translate(-279.051 -1164.598)"
}));
function SvgMediaRueda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.105,
    height: 173.313,
    viewBox: "0 0 143.105 173.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaRueda);
export default __webpack_public_path__ + "static/media/media-rueda.cfb58eb3c1028aaa5be8b8582320cad0.svg";
export { ForwardRef as ReactComponent };